import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevron = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 18L9 12L15 6", stroke: "black", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIconChevron);
export default ForwardRef;
